import React, { useEffect } from 'react';
import { UnitSizerPropTypes } from './UnitSizerPropTypes';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { Icon } from '../icon';
import {
  imgCarouselStyles,
  imgCarouselLR,
  txtCarouselLR,
  txtCarouselStyles,
  carouselIcon,
} from './constant';
import '../../style/unitSizer/unitSizer.css';

export const Carousel = ({
  isImage,
  selectedIndex,
  unitSizes,
  setSelectedIndex,
}: UnitSizerPropTypes.ICarouselProps) => {
  const totalLength = unitSizes.length;
  const prev = (selectedIndex - 1 + totalLength) % totalLength;
  const next = (selectedIndex + 1) % totalLength;

  useEffect(() => {
    const handleKeyPress = (event: any) => {
      if (event.key === 'ArrowLeft') {
        handleClick('left');
      } else if (event.key === 'ArrowRight') {
        handleClick('right');
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', handleKeyPress);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('keydown', handleKeyPress);
      }
    };
  }, [selectedIndex]);

  const ImageCarousel = () => (
    <>
      <Image
        src={unitSizes[prev].selectedImageUrl}
        alt={unitSizes[prev].imageAlt}
        w={{ base: '79.3px', sm: '88.3px', md: '158.3px' }}
        {...imgCarouselLR}
        onClick={() => handleClick('left')}
      />
      <Image
        src={unitSizes[selectedIndex].selectedImageUrl}
        alt={unitSizes[selectedIndex].imageAlt}
        {...imgCarouselStyles}
        w={{ base: '101.5px', sm: '131.2px', md: '263.8px' }}
      />
      <Image
        src={unitSizes[next].selectedImageUrl}
        alt={unitSizes[next].imageAlt}
        w={{ base: '79.3px', sm: '88.3px', md: '158.3px' }}
        {...imgCarouselLR}
        onClick={() => handleClick('right')}
      />
    </>
  );

  const TextCarousel = () => (
    <>
      <Text {...txtCarouselLR} onClick={() => handleClick('left')}>
        {unitSizes[prev].heading}
      </Text>
      <Text {...txtCarouselStyles}>{unitSizes[selectedIndex].heading}</Text>
      <Text {...txtCarouselLR} onClick={() => handleClick('right')}>
        {unitSizes[next].heading}
      </Text>
    </>
  );

  const handleClick = (action: string) => {
    let index = 0;
    if (action === 'left') {
      index = prev;
    } else if (action === 'right') {
      index = next;
    }
    setSelectedIndex(index);
  };

  return (
    <Flex justifyContent={{ base: 'center', sm: 'start' }} alignItems="center">
      {isImage ? (
        <>
          <Box className='sideArrowIcons' {...carouselIcon} onClick={() => handleClick('left')}>
            <Icon size="medium" className="icon-tfw-dropdown-open" />
          </Box>

          <ImageCarousel />

          <Box className='sideArrowIcons' {...carouselIcon} onClick={() => handleClick('right')}>
            <Icon size="medium" className="icon-tfw-dropdown-close" />
          </Box>
        </>
      ) : (
        <Box display={{ base: 'flex', sm: 'none' }} flexDirection="row" alignItems="center">
          <TextCarousel />
        </Box>
      )}
    </Flex>
  );
};
